import { defineMessages } from 'react-intl';

export default defineMessages({
    PedestrianQuestion: {
        id: 'wni.fnol.pa.views.incidentdetails.pedestrians.question',
        defaultMessage: "Were there any third party injuries?"
    },
    Yes: {
        id: 'wni.fnol.pa.views.incidentdetails.pedestrians.Yes',
        defaultMessage: "Yes"
    },
    No: {
        id: 'wni.fnol.pa.views.incidentdetails.pedestrians.No',
        defaultMessage: "No"
    },
    Number: {
        id: 'wni.fnol.pa.views.incidentdetails.pedestrians.No.',
        defaultMessage: "No."
    },
    PedestrianLastName: {
        id: 'wni.fnol.pa.views.incidentdetails.pedestrians.InjuryLastName',
        defaultMessage: "Injury Last Name"
    },
    Edit: {
        id: 'wni.fnol.pa.views.incidentdetails.pedestrians.Edit',
        defaultMessage: "Edit"
    },
    Delete: {
        id: 'wni.fnol.pa.views.incidentdetails.pedestrians.Delete',
        defaultMessage: "Delete"
    },
    AddPedestrian: {
        id: 'wni.fnol.pa.views.incidentdetails.pedestrians.AddInjuriedPerson',
        defaultMessage: "Add Injuried Person"
    }
})